import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { msalInstance } from '..';
import { getAccessToken } from './authHelper';

const httpLink = new HttpLink({
  uri: `${import.meta.env.VITE_BACKEND_API_URL}/p/activity`,
});

const authLink = setContext(async (_, { headers }) => {
  const storedToken = localStorage.getItem('token') || '';
  const accessToken = storedToken || (await getAccessToken(msalInstance));
  return {
    headers: {
      ...headers,
      Authorization: accessToken ? `Bearer ${accessToken}` : '',
    },
  };
});

export const client = new ApolloClient({
  link: ApolloLink.from([authLink, httpLink]),
  //   uri: `${import.meta.env.VITE_BACKEND_API_URL}/g/activity`,
  cache: new InMemoryCache(),
});
